import { ReactNode, createContext, useContext } from 'react';
import { RachelScope } from '../effects/rachelScope';

const RachelScopeContext = createContext<RachelScope | null>(null);

interface RachelScopeProviderProps {
  scope: RachelScope | null;
  children: ReactNode;
}

export const RachelScopeProvider = ({ scope, children }: RachelScopeProviderProps) => (
  <RachelScopeContext.Provider value={scope}>{children}</RachelScopeContext.Provider>
);

export const useRachelScope = () => useContext(RachelScopeContext);
